class SectionSwitcher extends HTMLElement {
  constructor() {
    super();

    this.$tabs = this.querySelector('tabs-component');    

    // this._collectSectionIds();
    this.sectionIds = [].concat(...[...this.querySelectorAll('[data-sections]')].map(el => el.dataset.sections.split(',')));
    this.$tabs.addEventListener('tabChange', this.switchSections.bind(this));
  }

  collectSectionIds() {
    const sectionDataEl = [...this.querySelectorAll('[data-sections]')];
    let sectionIdsPreFormat = sectionDataEl.map(el => el.dataset.sections.split(','));
    let sectionIds = [];

    sectionIdsPreFormat.forEach(ar => {
      ar.forEach(id => sectionIds.push(id));
    })
    
  }
  
  switchSections(e) {
    const tabToggler = e.detail.tabTogglers[0];
    const sectionIds = tabToggler.dataset.sections;

    if (sectionIds === "") return;
    
    this.sectionIds.forEach(sid => {
      let section = document.getElementById(sid);
      if (!section) return;
      if (sectionIds.includes(sid)) {        
        section.style.display = 'block';
      } else {
        section.style.display = 'none';
      }
    })
    
  }
}

customElements.define('section-switcher', SectionSwitcher);